import { useContext, useEffect, useState } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import remove from "lodash/remove";
import AppGlobalsContext from "app/AppGlobalsContext";

export const useCountries = () => {
	const { track } = useAnalytics();

	const [countries, setCountries] = useState([]);

	const { shop } = useContext(AppGlobalsContext);

	useEffect(() => {
		if (shop) {
			const [locale, countryCode] = shop.split("-");

			import(`world_countries_lists/data/countries/${locale}/countries.json`)
				.then(module => {
					const finalCountries = [...module.default].sort((a, b) =>
						a.name.localeCompare(b.name, locale)
					);

					let computedCountries = finalCountries.map(country => {
						country.cca2 = country.alpha2.toUpperCase();
						// do not display "United Kingdom of Great Britain and Northern Ireland"
						if (country.cca2 === "GB") {
							country.name = "United Kingdom";
						}
						return country;
					});

					let currentCountry = find(computedCountries, { alpha2: countryCode });

					if (currentCountry) {
						remove(computedCountries, currentCountry);
						computedCountries = [currentCountry, ...computedCountries];
					}

					setCountries(computedCountries);
				})
				.catch(error => {
					// eslint-disable-next-line no-console
					console.error(error);
					track("error", { error });
				});
		}
	}, [shop]);

	return countries;
};
